module.exports = __webpack_public_path__ + "static/media/RLND_10.4cb2da8a.png";